import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import {
  VictoryChart,
  VictoryAxis,
  VictoryArea,
  VictoryScatter,
  VictoryBar
} from 'victory'
import ContainerWidthSizer from '../../UI/ContainerWidthSizer'

const leftPoints = [
    [0, 0],
    [1, 0],
    [0, 1],
    [1, 1]
  ],
  rightPoints = [
    [0, 1],
    [1, 1],
    [0, 0],
    [1, 0]
  ]

export default function BedtimeChart(props) {
  const { startTime, endTime, idealMealTime, largestMealTime } = props
  const leftCurve = bezier.apply(null, leftPoints),
    rightCurve = bezier.apply(null, rightPoints)
  let tickValuesX = _.union(
    [startTime, endTime, idealMealTime, largestMealTime].sort((a, b) => a - b)
  )
  const x0 = startTime,
    x1 = endTime
  return (
    <>
      <ContainerWidthSizer>
        {({ width }) => {
          const dots = getDots(width)
          return (
            <VictoryChart
              width={width}
              height={180}
              minDomain={{ x: x0, y: 0 }}
              padding={{
                top: 50,
                bottom: 0,
                left: 30,
                right: 30
              }}
            >
              <VictoryAxis
                tickValues={[0, 1]}
                dependentAxis
                style={{
                  axis: {
                    stroke: 'transparent'
                  },
                  tickLabels: {
                    fill: 'transparent'
                  }
                }}
              />
              <VictoryArea
                style={{
                  data: {
                    fill: 'url(#lg2)'
                  }
                }}
                y={(d) => {
                  if (d.x === largestMealTime) {
                    return 1
                  }
                  if (d.x >= x0 && d.x <= x1) {
                    return d.x > largestMealTime
                      ? rightCurve(
                          getT(d.x, {
                            start: largestMealTime,
                            end: endTime,
                            points: leftPoints
                          })
                        ).y
                      : leftCurve(
                          getT(d.x, {
                            start: startTime,
                            end: largestMealTime,
                            points: rightPoints
                          })
                        ).y
                  } else {
                    return null
                  }
                }}
              />
              <VictoryArea
                style={{
                  data: {
                    fill: 'url(#lg1)'
                  }
                }}
                y={(d) => {
                  if (d.x >= x0 && d.x <= x1) {
                    return d.x > idealMealTime
                      ? rightCurve(
                          getT(d.x, {
                            start: idealMealTime,
                            end: endTime,
                            points: leftPoints
                          })
                        ).y
                      : leftCurve(
                          getT(d.x, {
                            start: startTime,
                            end: idealMealTime,
                            points: rightPoints
                          })
                        ).y
                  } else {
                    return null
                  }
                }}
              />
              <VictoryAxis
                tickValues={tickValuesX}
                // tickFormat={(t) => moment(t).format('h:mm A')}
                style={{
                  grid: {
                    strokeWidth: 1.5,
                    stroke: (tickValue) =>
                      tickValue === idealMealTime ||
                      tickValue === largestMealTime
                        ? '#ffffff'
                        : 'transparent',
                    strokeDasharray: '3, 3'
                  },
                  axis: {
                    stroke: 'transparent'
                  },
                  tickLabels: {
                    fill: 'transparent'
                  }
                }}
              />
              <VictoryScatter
                data={dots}
                dataComponent={<IdealScatter />}
                style={{
                  labels: {
                    fill: 'transparent'
                  }
                }}
              />
              {_.cloneDeep(dots).map((dot, index) => {
                dot.y = 1
                return (
                  <VictoryBar
                    key={index}
                    data={[dot]}
                    style={{
                      data: {
                        fill: 'transparent'
                      },
                      labels: {
                        fill: (datum) => datum.labelColor,
                        padding: dot.labelOffset ? 30 : 10
                      }
                    }}
                    labels={(datum) => moment(datum.x).format('h:mm A')}
                  />
                )
              })}
              {/* <VictoryBar
                data={[
                  { x: x0, y: (200 * 0.04) / 100 },
                  { x: x1, y: (200 * 0.04) / 100 }
                ]}
                barWidth={1.5}
                style={{
                  data: {
                    fill: '#9DACBB'
                  },
                  labels: {
                    fill: '#9DACBB',
                    textAnchor: (datum) => (datum.x === x0 ? 'start' : 'end')
                  }
                }}
                labels={(datum) => moment(datum.x).format('h:mm A')}
              /> */}
            </VictoryChart>
          )
        }}
      </ContainerWidthSizer>
      <svg style={{ height: 200, position: 'absolute' }}>
        <defs>
          <linearGradient id="lg1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0" stopColor="#ABD5B2" />
            <stop offset="1" stopColor="rgba(123, 173, 45, 0)" />
          </linearGradient>
        </defs>
        <defs>
          <linearGradient
            id="lg2"
            x1="279"
            y1="0"
            x2="279"
            y2="343.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0E3076" />
            <stop offset="1" stopColor="#2B4B8E" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </>
  )

  function getDots(wholeWidth) {
    const limit = (38 + 66) / (2 * wholeWidth),
      labelLimit = 100 / (2 * wholeWidth)
    const distancePCT =
      Math.abs(idealMealTime - largestMealTime) / (endTime - startTime)
    let offset = 0,
      labelOffset = false
    if (distancePCT === 0) {
      return [
        {
          x: idealMealTime,
          y: 0.5,
          type: 'Reached Ideal LM',
          offset,
          labelColor: '#468527',
          isEqual: true
        }
      ]
    }
    if (distancePCT < limit) {
      offset = 20
    }
    if (distancePCT < labelLimit) {
      labelOffset = true
    }
    const dots = [
      {
        x: idealMealTime,
        y: 0.5,
        type: 'Ideal LM',
        offset,
        labelColor: '#468527'
      },
      {
        x: largestMealTime,
        y: 0.5,
        type: 'LM',
        offset: offset * -1,
        labelOffset,
        labelColor: '#405D99'
      }
    ]
    return dots
  }
}

function IdealScatter(props) {
  const { x, y, datum } = props
  if (datum.isEqual) {
    return (
      <svg
        width="112"
        height="34"
        viewBox="0 0 112 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...{ x: x - 56, y: y - 17 }}
      >
        <rect
          x="4"
          width="104"
          height="26"
          rx="13"
          fill="white"
          shapeRendering="crispEdges"
        />
        <rect
          x="4.5"
          y="0.5"
          width="103"
          height="25"
          rx="12.5"
          stroke="#468527"
          shapeRendering="crispEdges"
        />

        <text x="15" y="16" fontSize={10} fontWeight={600}>
          <tspan fill="#468527">{datum.type}</tspan>
        </text>
      </svg>
    )
  }
  if (datum.type === 'LM') {
    return (
      <svg
        width="65"
        height="34"
        viewBox="0 0 65 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...{ x: x - 19, y: y - 17 + datum.offset || 0 }}
      >
        <g filter="url(#filter0_d_53536_2344)">
          <rect
            x="4"
            width="57"
            height="26"
            rx="13"
            fill="white"
            shapeRendering="crispEdges"
          />
          <path
            d="M16.82 12.37C17.13 12.53 17.37 12.75 17.54 13.03C17.71 13.31 17.8 13.63 17.8 14C17.8 14.57 17.6 15.05 17.19 15.43C16.78 15.81 16.29 16 15.7 16H12.7V9H15.48C16.05 9 16.54 9.18 16.94 9.55C17.33 9.92 17.53 10.39 17.53 10.94C17.53 11.55 17.29 12.02 16.82 12.37ZM15.48 10.08H13.85V11.92H15.48C15.73 11.92 15.95 11.83 16.12 11.65C16.29 11.48 16.38 11.26 16.38 11C16.38 10.74 16.29 10.52 16.12 10.34C15.95 10.17 15.73 10.08 15.48 10.08ZM13.85 14.92H15.7C15.97 14.92 16.19 14.82 16.38 14.63C16.56 14.44 16.65 14.21 16.65 13.94C16.65 13.67 16.56 13.43 16.38 13.24C16.19 13.05 15.97 12.96 15.7 12.96H13.85V14.92ZM23.8635 13.96H19.8835C19.9635 14.34 20.1435 14.63 20.4335 14.83C20.7235 15.04 21.0735 15.14 21.4835 15.14C22.0535 15.14 22.4835 14.93 22.7735 14.52L23.6635 15.04C23.1735 15.77 22.4435 16.13 21.4735 16.13C20.6635 16.13 20.0035 15.88 19.5035 15.38C19.0035 14.89 18.7535 14.26 18.7535 13.5C18.7535 12.75 19.0035 12.13 19.4935 11.62C19.9835 11.12 20.6235 10.87 21.3935 10.87C22.1235 10.87 22.7335 11.13 23.2035 11.64C23.6735 12.15 23.9035 12.78 23.9035 13.51C23.9035 13.62 23.8935 13.77 23.8635 13.96ZM19.8735 13.08H22.8135C22.7435 12.67 22.5735 12.37 22.3135 12.16C22.0435 11.95 21.7335 11.85 21.3835 11.85C20.9835 11.85 20.6535 11.96 20.3835 12.18C20.1135 12.4 19.9435 12.7 19.8735 13.08ZM29.1138 11.71V9H30.1938V16H29.1138V15.28C28.7038 15.85 28.1238 16.13 27.3638 16.13C26.6738 16.13 26.0938 15.87 25.6038 15.36C25.1138 14.85 24.8738 14.23 24.8738 13.5C24.8738 12.76 25.1138 12.14 25.6038 11.63C26.0938 11.12 26.6738 10.87 27.3638 10.87C28.1238 10.87 28.7038 11.15 29.1138 11.71ZM26.4038 14.64C26.7038 14.95 27.0838 15.1 27.5338 15.1C27.9838 15.1 28.3638 14.95 28.6638 14.64C28.9638 14.34 29.1138 13.96 29.1138 13.5C29.1138 13.04 28.9638 12.66 28.6638 12.35C28.3638 12.05 27.9838 11.9 27.5338 11.9C27.0838 11.9 26.7038 12.05 26.4038 12.35C26.1038 12.66 25.9538 13.04 25.9538 13.5C25.9538 13.96 26.1038 14.34 26.4038 14.64ZM34.5427 11V12.04H33.3027V14.44C33.3027 14.65 33.3527 14.79 33.4427 14.88C33.5327 14.97 33.6727 15.02 33.8627 15.03C34.0427 15.04 34.2727 15.04 34.5427 15.03V16C33.7127 16.1 33.1227 16.03 32.7627 15.78C32.4027 15.54 32.2227 15.09 32.2227 14.44V12.04H31.3027V11H32.2227V9.92L33.3027 9.6V11H34.5427ZM36.901 10.04C36.761 10.18 36.601 10.25 36.411 10.25C36.221 10.25 36.061 10.18 35.931 10.04C35.791 9.91 35.721 9.75 35.721 9.56C35.721 9.37 35.791 9.21 35.921 9.07C36.051 8.94 36.221 8.87 36.411 8.87C36.601 8.87 36.771 8.94 36.901 9.07C37.031 9.21 37.101 9.37 37.101 9.56C37.101 9.75 37.031 9.91 36.901 10.04ZM36.951 16H35.871V11H36.951V16ZM43.965 10.87C44.535 10.87 44.985 11.05 45.335 11.42C45.685 11.79 45.855 12.28 45.855 12.9V16H44.775V12.97C44.775 12.62 44.685 12.35 44.515 12.16C44.345 11.97 44.105 11.88 43.805 11.88C43.475 11.88 43.205 11.99 43.015 12.21C42.815 12.43 42.715 12.76 42.715 13.2V16H41.635V12.97C41.635 12.62 41.555 12.35 41.395 12.16C41.225 11.97 40.995 11.88 40.695 11.88C40.365 11.88 40.105 11.99 39.895 12.21C39.685 12.44 39.585 12.77 39.585 13.2V16H38.505V11H39.585V11.6C39.905 11.11 40.385 10.87 41.015 10.87C41.655 10.87 42.125 11.13 42.435 11.66C42.765 11.13 43.275 10.87 43.965 10.87ZM52.1409 13.96H48.1609C48.2409 14.34 48.4209 14.63 48.7109 14.83C49.0009 15.04 49.3509 15.14 49.7609 15.14C50.3309 15.14 50.7609 14.93 51.0509 14.52L51.9409 15.04C51.4509 15.77 50.7209 16.13 49.7509 16.13C48.9409 16.13 48.2809 15.88 47.7809 15.38C47.2809 14.89 47.0309 14.26 47.0309 13.5C47.0309 12.75 47.2809 12.13 47.7709 11.62C48.2609 11.12 48.9009 10.87 49.6709 10.87C50.4009 10.87 51.0109 11.13 51.4809 11.64C51.9509 12.15 52.1809 12.78 52.1809 13.51C52.1809 13.62 52.1709 13.77 52.1409 13.96ZM48.1509 13.08H51.0909C51.0209 12.67 50.8509 12.37 50.5909 12.16C50.3209 11.95 50.0109 11.85 49.6609 11.85C49.2609 11.85 48.9309 11.96 48.6609 12.18C48.3909 12.4 48.2209 12.7 48.1509 13.08Z"
            fill="#355493"
          />
          <rect
            x="4.5"
            y="0.5"
            width="56"
            height="25"
            rx="12.5"
            stroke="#365594"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_53536_2344"
            x="0"
            y="0"
            width="65"
            height="34"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_53536_2344"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_53536_2344"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  }
  return (
    <svg
      width="93"
      height="34"
      viewBox="0 0 93 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ x: x - 33, y: y - 17 + datum.offset || 0 }}
    >
      <g filter="url(#filter0_d_53536_1588)">
        <rect
          x="4"
          width="85"
          height="26"
          rx="13"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M12.7 16V9H13.85V16H12.7ZM19.4388 11.71V9H20.5188V16H19.4388V15.28C19.0288 15.85 18.4488 16.13 17.6888 16.13C16.9988 16.13 16.4188 15.87 15.9288 15.36C15.4388 14.85 15.1988 14.23 15.1988 13.5C15.1988 12.76 15.4388 12.14 15.9288 11.63C16.4188 11.12 16.9988 10.87 17.6888 10.87C18.4488 10.87 19.0288 11.15 19.4388 11.71ZM16.7288 14.64C17.0288 14.95 17.4088 15.1 17.8588 15.1C18.3088 15.1 18.6888 14.95 18.9888 14.64C19.2888 14.34 19.4388 13.96 19.4388 13.5C19.4388 13.04 19.2888 12.66 18.9888 12.35C18.6888 12.05 18.3088 11.9 17.8588 11.9C17.4088 11.9 17.0288 12.05 16.7288 12.35C16.4288 12.66 16.2788 13.04 16.2788 13.5C16.2788 13.96 16.4288 14.34 16.7288 14.64ZM26.9077 13.96H22.9277C23.0077 14.34 23.1877 14.63 23.4777 14.83C23.7677 15.04 24.1177 15.14 24.5277 15.14C25.0977 15.14 25.5277 14.93 25.8177 14.52L26.7077 15.04C26.2177 15.77 25.4877 16.13 24.5177 16.13C23.7077 16.13 23.0477 15.88 22.5477 15.38C22.0477 14.89 21.7977 14.26 21.7977 13.5C21.7977 12.75 22.0477 12.13 22.5377 11.62C23.0277 11.12 23.6677 10.87 24.4377 10.87C25.1677 10.87 25.7777 11.13 26.2477 11.64C26.7177 12.15 26.9477 12.78 26.9477 13.51C26.9477 13.62 26.9377 13.77 26.9077 13.96ZM22.9177 13.08H25.8577C25.7877 12.67 25.6177 12.37 25.3577 12.16C25.0877 11.95 24.7777 11.85 24.4277 11.85C24.0277 11.85 23.6977 11.96 23.4277 12.18C23.1577 12.4 22.9877 12.7 22.9177 13.08ZM32.158 11.71V11H33.238V16H32.158V15.28C31.748 15.85 31.168 16.13 30.408 16.13C29.718 16.13 29.138 15.87 28.648 15.36C28.158 14.85 27.918 14.23 27.918 13.5C27.918 12.76 28.158 12.14 28.648 11.63C29.138 11.12 29.718 10.87 30.408 10.87C31.168 10.87 31.748 11.15 32.158 11.71ZM29.448 14.64C29.748 14.95 30.128 15.1 30.578 15.1C31.028 15.1 31.408 14.95 31.708 14.64C32.008 14.34 32.158 13.96 32.158 13.5C32.158 13.04 32.008 12.66 31.708 12.35C31.408 12.05 31.028 11.9 30.578 11.9C30.128 11.9 29.748 12.05 29.448 12.35C29.148 12.66 28.998 13.04 28.998 13.5C28.998 13.96 29.148 14.34 29.448 14.64ZM35.8768 16H34.7968V8.7H35.8768V16ZM44.4208 12.37C44.7308 12.53 44.9708 12.75 45.1408 13.03C45.3108 13.31 45.4008 13.63 45.4008 14C45.4008 14.57 45.2008 15.05 44.7908 15.43C44.3808 15.81 43.8908 16 43.3008 16H40.3008V9H43.0808C43.6508 9 44.1408 9.18 44.5408 9.55C44.9308 9.92 45.1308 10.39 45.1308 10.94C45.1308 11.55 44.8908 12.02 44.4208 12.37ZM43.0808 10.08H41.4508V11.92H43.0808C43.3308 11.92 43.5508 11.83 43.7208 11.65C43.8908 11.48 43.9808 11.26 43.9808 11C43.9808 10.74 43.8908 10.52 43.7208 10.34C43.5508 10.17 43.3308 10.08 43.0808 10.08ZM41.4508 14.92H43.3008C43.5708 14.92 43.7908 14.82 43.9808 14.63C44.1608 14.44 44.2508 14.21 44.2508 13.94C44.2508 13.67 44.1608 13.43 43.9808 13.24C43.7908 13.05 43.5708 12.96 43.3008 12.96H41.4508V14.92ZM51.4643 13.96H47.4843C47.5643 14.34 47.7443 14.63 48.0343 14.83C48.3243 15.04 48.6743 15.14 49.0843 15.14C49.6543 15.14 50.0843 14.93 50.3743 14.52L51.2643 15.04C50.7743 15.77 50.0443 16.13 49.0743 16.13C48.2643 16.13 47.6043 15.88 47.1043 15.38C46.6043 14.89 46.3543 14.26 46.3543 13.5C46.3543 12.75 46.6043 12.13 47.0943 11.62C47.5843 11.12 48.2243 10.87 48.9943 10.87C49.7243 10.87 50.3343 11.13 50.8043 11.64C51.2743 12.15 51.5043 12.78 51.5043 13.51C51.5043 13.62 51.4943 13.77 51.4643 13.96ZM47.4743 13.08H50.4143C50.3443 12.67 50.1743 12.37 49.9143 12.16C49.6443 11.95 49.3343 11.85 48.9843 11.85C48.5843 11.85 48.2543 11.96 47.9843 12.18C47.7143 12.4 47.5443 12.7 47.4743 13.08ZM56.7146 11.71V9H57.7946V16H56.7146V15.28C56.3046 15.85 55.7246 16.13 54.9646 16.13C54.2746 16.13 53.6946 15.87 53.2046 15.36C52.7146 14.85 52.4746 14.23 52.4746 13.5C52.4746 12.76 52.7146 12.14 53.2046 11.63C53.6946 11.12 54.2746 10.87 54.9646 10.87C55.7246 10.87 56.3046 11.15 56.7146 11.71ZM54.0046 14.64C54.3046 14.95 54.6846 15.1 55.1346 15.1C55.5846 15.1 55.9646 14.95 56.2646 14.64C56.5646 14.34 56.7146 13.96 56.7146 13.5C56.7146 13.04 56.5646 12.66 56.2646 12.35C55.9646 12.05 55.5846 11.9 55.1346 11.9C54.6846 11.9 54.3046 12.05 54.0046 12.35C53.7046 12.66 53.5546 13.04 53.5546 13.5C53.5546 13.96 53.7046 14.34 54.0046 14.64ZM62.1434 11V12.04H60.9034V14.44C60.9034 14.65 60.9534 14.79 61.0434 14.88C61.1334 14.97 61.2734 15.02 61.4634 15.03C61.6434 15.04 61.8734 15.04 62.1434 15.03V16C61.3134 16.1 60.7234 16.03 60.3634 15.78C60.0034 15.54 59.8234 15.09 59.8234 14.44V12.04H58.9034V11H59.8234V9.92L60.9034 9.6V11H62.1434ZM64.5018 10.04C64.3618 10.18 64.2018 10.25 64.0118 10.25C63.8218 10.25 63.6618 10.18 63.5318 10.04C63.3918 9.91 63.3218 9.75 63.3218 9.56C63.3218 9.37 63.3918 9.21 63.5218 9.07C63.6518 8.94 63.8218 8.87 64.0118 8.87C64.2018 8.87 64.3718 8.94 64.5018 9.07C64.6318 9.21 64.7018 9.37 64.7018 9.56C64.7018 9.75 64.6318 9.91 64.5018 10.04ZM64.5518 16H63.4718V11H64.5518V16ZM71.5658 10.87C72.1358 10.87 72.5858 11.05 72.9358 11.42C73.2858 11.79 73.4558 12.28 73.4558 12.9V16H72.3758V12.97C72.3758 12.62 72.2858 12.35 72.1158 12.16C71.9458 11.97 71.7058 11.88 71.4058 11.88C71.0758 11.88 70.8058 11.99 70.6158 12.21C70.4158 12.43 70.3158 12.76 70.3158 13.2V16H69.2358V12.97C69.2358 12.62 69.1558 12.35 68.9958 12.16C68.8258 11.97 68.5958 11.88 68.2958 11.88C67.9658 11.88 67.7058 11.99 67.4958 12.21C67.2858 12.44 67.1858 12.77 67.1858 13.2V16H66.1058V11H67.1858V11.6C67.5058 11.11 67.9858 10.87 68.6158 10.87C69.2558 10.87 69.7258 11.13 70.0358 11.66C70.3658 11.13 70.8758 10.87 71.5658 10.87ZM79.7416 13.96H75.7616C75.8416 14.34 76.0216 14.63 76.3116 14.83C76.6016 15.04 76.9516 15.14 77.3616 15.14C77.9316 15.14 78.3616 14.93 78.6516 14.52L79.5416 15.04C79.0516 15.77 78.3216 16.13 77.3516 16.13C76.5416 16.13 75.8816 15.88 75.3816 15.38C74.8816 14.89 74.6316 14.26 74.6316 13.5C74.6316 12.75 74.8816 12.13 75.3716 11.62C75.8616 11.12 76.5016 10.87 77.2716 10.87C78.0016 10.87 78.6116 11.13 79.0816 11.64C79.5516 12.15 79.7816 12.78 79.7816 13.51C79.7816 13.62 79.7716 13.77 79.7416 13.96ZM75.7516 13.08H78.6916C78.6216 12.67 78.4516 12.37 78.1916 12.16C77.9216 11.95 77.6116 11.85 77.2616 11.85C76.8616 11.85 76.5316 11.96 76.2616 12.18C75.9916 12.4 75.8216 12.7 75.7516 13.08Z"
          fill="#468527"
        />
        <rect
          x="4.5"
          y="0.5"
          width="84"
          height="25"
          rx="12.5"
          stroke="#73C54A"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_53536_1588"
          x="0"
          y="0"
          width="93"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_53536_1588"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_53536_1588"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

function getT(x, { start, end, points }) {
  const scale = end - start
  return (x - start) / scale
}

function bezier(p1, cp1, cp2, p2) {
  const [x1, y1] = p1
  const [x2, y2] = p2
  const [cx1, cy1] = cp1
  const [cx2, cy2] = cp2
  return (t) => {
    let x =
      x1 * (1 - t) * (1 - t) * (1 - t) +
      3 * cx1 * t * (1 - t) * (1 - t) +
      3 * cx2 * t * t * (1 - t) +
      x2 * t * t * t
    let y =
      y1 * (1 - t) * (1 - t) * (1 - t) +
      3 * cy1 * t * (1 - t) * (1 - t) +
      3 * cy2 * t * t * (1 - t) +
      y2 * t * t * t
    return { x, y }
  }
}
